// Supervising-physician attestation for mid-level providers (NP/PA) in the note
// editor.
//
// care.brainymed hardcodes an allowlist of NP usernames for ITS practice (9928)
// and names its own supervising MD in the attestation text. Neither travels to
// another practice: copied verbatim, the checkbox would appear for whichever
// users happened to share those usernames and would name the wrong physician.
//
// So this instance derives it instead — the checkbox shows only for users whose
// role marks them as a mid-level, and the wording is practice-neutral. A
// practice with no mid-levels (e.g. 7825) simply never sees it, which is the
// correct default for a freshly provisioned practice.
const MIDLEVEL_ROLES = new Set([
  "np", "pa", "nurse practitioner", "physician assistant", "midlevel", "mid-level",
]);

export const ATTESTATION_LINE =
  "Discussed chart, assessment, and plan with the supervising physician";

// Accepts the /auth/me user object (redux state.userconfig). A bare username
// string returns false: a username alone can't tell us whether someone is a
// mid-level without importing another practice's roster.
export function isNpAttestationUser(user) {
  if (!user || typeof user !== "object") return false;
  const role = String(user.role ?? "").trim().toLowerCase();
  const grole = String(user.grole ?? "").trim().toLowerCase();
  return MIDLEVEL_ROLES.has(role) || MIDLEVEL_ROLES.has(grole);
}

// Returns the assessment_plan with the attestation line appended if checked,
// or removed if unchecked. Handles both list[str] and string shapes since
// note_json.assessment_plan can be either depending on the template.
export function applyAttestationToPlan(currentPlan, checked) {
  const line = ATTESTATION_LINE;
  if (Array.isArray(currentPlan)) {
    const filtered = currentPlan.filter(item => {
      if (typeof item !== "string") return true;
      return item.trim() !== line && !item.trim().endsWith(line);
    });
    return checked ? [...filtered, line] : filtered;
  }
  if (typeof currentPlan === "string") {
    // Strip any prior occurrence (with or without leading bullet/dash) then
    // append on its own line if checked.
    const lines = currentPlan
      .split(/\r?\n/)
      .map(l => l.replace(/^[\s\-•]+/, "").trim())
      .filter(l => l && l !== line && !l.endsWith(line));
    const restored = lines.map(l => l).join("\n");
    return checked ? `${restored}${restored ? "\n" : ""}${line}` : restored;
  }
  return checked ? [line] : currentPlan;
}
